<template>
  <OptionForm @submit="addLight" @close="$emit('closeMenus')">
    <ColorForm label="Color" :def="color" @onChange="setColor" />
    <InputForm label="Intensity" type="number" :def="intensity" @onChange="setIntensity" />
<!--    <InputForm label="Decay" type="number" :def="decay" @onChange="setDecay" />-->
    <InputForm label="Angle" type="number" :def="angle" @onChange="setAngle" />
<!--    <InputForm label="Penumbra" type="number" :def="penumbra" @onChange="setPenumbra" />-->
    <InputForm label="Distance" type="number" :def="distance" @onChange="setDistance" />
    <CheckboxForm label="Cast Shadow" :def="castShadow" @onChange="setCastShadow" />
  </OptionForm>
</template>

<script>
import {MathUtils} from "three";
import * as REAL from "real_api"
import ColorForm from "@/components/form/option/ColorForm.vue";
import InputForm from "@/components/form/option/InputForm.vue";
import OptionForm from "@/components/form/option/OptionForm.vue";
import CheckboxForm from "@/components/form/option/CheckboxForm.vue";
import {convertHTMLColorToThreeColor} from "@/render_utils/three_tools/creation_tools/color_tools";

export default {
  name: 'AddSpotLight',
  emits: ['closeMenus', 'addSceneItem'],
  components: {InputForm, CheckboxForm, OptionForm, ColorForm},
  data() {
    return {
      color: '#FFFFFF',
      decay: 2.0,
      angle: 30.0,
      penumbra: 0,
      intensity: 10,
      distance: 5.0,
      castShadow: true,
    }
  },
  methods: {
    addLight() {
      this.$emit("closeMenus");
      const color  = convertHTMLColorToThreeColor(this.color);
      const angle = MathUtils.degToRad(this.angle);
      const light = new REAL.SpotLight({
        color: color,
        angle: angle,
        decay: this.decay,
        penumbra: this.penumbra,
        distance: this.distance,
        intensity: this.intensity,
        castShadow: this.castShadow,
      });
      this.$emit("addSceneItem", light, "spot_light");
    },
    setColor(value){this.color = value},
    setDecay(value){this.decay = value},
    setAngle(value){this.angle = value},
    setPenumbra(value){this.penumbra = value},
    setDistance(value){this.distance = value},
    setCastShadow(value){this.castShadow = value},
    setIntensity(value){this.intensity = value},
  }
};
</script>
